/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { CampaignGenerateRequest } from '../model/campaignGenerateRequest';
import { CampaignGiftRequest } from '../model/campaignGiftRequest';
import { CampaignProductValidationRequest } from '../model/campaignProductValidationRequest';
import { CampaignRequest } from '../model/campaignRequest';
import { CampaignSubscriptionTypeRequest } from '../model/campaignSubscriptionTypeRequest';
import { ResponseB4ACampaign } from '../model/responseB4ACampaign';
import { ResponseB4ACampaignHistorySummaryDTO } from '../model/responseB4ACampaignHistorySummaryDTO';
import { ResponseB4ACampaignProductValidationDTO } from '../model/responseB4ACampaignProductValidationDTO';
import { ResponseB4AListCampaign } from '../model/responseB4AListCampaign';
import { ResponseB4AListCampaignEligibleCustomerDTO } from '../model/responseB4AListCampaignEligibleCustomerDTO';
import { ResponseB4AListCampaignExecutionCustomer } from '../model/responseB4AListCampaignExecutionCustomer';
import { ResponseB4AListCampaignGift } from '../model/responseB4AListCampaignGift';
import { ResponseB4AListCampaignSubscriptionType } from '../model/responseB4AListCampaignSubscriptionType';
import { ResponseB4AMapStringObject } from '../model/responseB4AMapStringObject';

import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';

@Injectable()
export class CampaignControllerService {
  public configuration = new Configuration();

  public defaultHeaders = new HttpHeaders();
  protected basePath = 'http://localhost:8080';
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCampaign(
    body: CampaignRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ACampaign>;
  public createCampaign(
    body: CampaignRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ACampaign>>;
  public createCampaign(
    body: CampaignRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ACampaign>>;
  public createCampaign(
    body: CampaignRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling createCampaign.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4ACampaign>(
      'post',
      `${this.basePath}/campaign`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param campaignId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateCampaign(
    body: CampaignGenerateRequest,
    campaignId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AMapStringObject>;
  public generateCampaign(
    body: CampaignGenerateRequest,
    campaignId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AMapStringObject>>;
  public generateCampaign(
    body: CampaignGenerateRequest,
    campaignId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AMapStringObject>>;
  public generateCampaign(
    body: CampaignGenerateRequest,
    campaignId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling generateCampaign.'
      );
    }

    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling generateCampaign.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AMapStringObject>(
      'post',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}/generate`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param campaignId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCampaign(
    campaignId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ACampaign>;
  public getCampaign(
    campaignId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ACampaign>>;
  public getCampaign(
    campaignId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ACampaign>>;
  public getCampaign(
    campaignId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling getCampaign.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4ACampaign>(
      'get',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param campaignId
   * @param executionId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHistorySummary(
    campaignId: number,
    executionId?: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ACampaignHistorySummaryDTO>;
  public getHistorySummary(
    campaignId: number,
    executionId?: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ACampaignHistorySummaryDTO>>;
  public getHistorySummary(
    campaignId: number,
    executionId?: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ACampaignHistorySummaryDTO>>;
  public getHistorySummary(
    campaignId: number,
    executionId?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling getHistorySummary.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (executionId !== undefined && executionId !== null) {
      queryParameters = queryParameters.set('executionId', <any>executionId);
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4ACampaignHistorySummaryDTO>(
      'get',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}/history`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listCampaigns(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListCampaign>;
  public listCampaigns(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListCampaign>>;
  public listCampaigns(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListCampaign>>;
  public listCampaigns(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListCampaign>(
      'get',
      `${this.basePath}/campaign`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param campaignId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listEligibleCustomers(
    campaignId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListCampaignEligibleCustomerDTO>;
  public listEligibleCustomers(
    campaignId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListCampaignEligibleCustomerDTO>>;
  public listEligibleCustomers(
    campaignId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListCampaignEligibleCustomerDTO>>;
  public listEligibleCustomers(
    campaignId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling listEligibleCustomers.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListCampaignEligibleCustomerDTO>(
      'get',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}/eligible-customers`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param campaignId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listGifts(
    campaignId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListCampaignGift>;
  public listGifts(
    campaignId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListCampaignGift>>;
  public listGifts(
    campaignId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListCampaignGift>>;
  public listGifts(
    campaignId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling listGifts.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListCampaignGift>(
      'get',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}/gifts`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param campaignId
   * @param executionId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listHistoryCustomers(
    campaignId: number,
    executionId?: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListCampaignExecutionCustomer>;
  public listHistoryCustomers(
    campaignId: number,
    executionId?: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListCampaignExecutionCustomer>>;
  public listHistoryCustomers(
    campaignId: number,
    executionId?: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListCampaignExecutionCustomer>>;
  public listHistoryCustomers(
    campaignId: number,
    executionId?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling listHistoryCustomers.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (executionId !== undefined && executionId !== null) {
      queryParameters = queryParameters.set('executionId', <any>executionId);
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListCampaignExecutionCustomer>(
      'get',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}/history/customers`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param campaignId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listSubscriptionTypes(
    campaignId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListCampaignSubscriptionType>;
  public listSubscriptionTypes(
    campaignId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListCampaignSubscriptionType>>;
  public listSubscriptionTypes(
    campaignId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListCampaignSubscriptionType>>;
  public listSubscriptionTypes(
    campaignId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling listSubscriptionTypes.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListCampaignSubscriptionType>(
      'get',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}/subscription-types`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param campaignId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public replaceGifts(
    body: CampaignGiftRequest,
    campaignId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListCampaignGift>;
  public replaceGifts(
    body: CampaignGiftRequest,
    campaignId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListCampaignGift>>;
  public replaceGifts(
    body: CampaignGiftRequest,
    campaignId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListCampaignGift>>;
  public replaceGifts(
    body: CampaignGiftRequest,
    campaignId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling replaceGifts.'
      );
    }

    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling replaceGifts.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AListCampaignGift>(
      'post',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}/gifts`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param campaignId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public replaceSubscriptionTypes(
    body: CampaignSubscriptionTypeRequest,
    campaignId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListCampaignSubscriptionType>;
  public replaceSubscriptionTypes(
    body: CampaignSubscriptionTypeRequest,
    campaignId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListCampaignSubscriptionType>>;
  public replaceSubscriptionTypes(
    body: CampaignSubscriptionTypeRequest,
    campaignId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListCampaignSubscriptionType>>;
  public replaceSubscriptionTypes(
    body: CampaignSubscriptionTypeRequest,
    campaignId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling replaceSubscriptionTypes.'
      );
    }

    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling replaceSubscriptionTypes.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4AListCampaignSubscriptionType>(
      'post',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}/subscription-types`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param campaignId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCampaign(
    body: CampaignRequest,
    campaignId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ACampaign>;
  public updateCampaign(
    body: CampaignRequest,
    campaignId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ACampaign>>;
  public updateCampaign(
    body: CampaignRequest,
    campaignId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ACampaign>>;
  public updateCampaign(
    body: CampaignRequest,
    campaignId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling updateCampaign.'
      );
    }

    if (campaignId === null || campaignId === undefined) {
      throw new Error(
        'Required parameter campaignId was null or undefined when calling updateCampaign.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4ACampaign>(
      'put',
      `${this.basePath}/campaign/${encodeURIComponent(String(campaignId))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateProduct(
    body: CampaignProductValidationRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ACampaignProductValidationDTO>;
  public validateProduct(
    body: CampaignProductValidationRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ACampaignProductValidationDTO>>;
  public validateProduct(
    body: CampaignProductValidationRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ACampaignProductValidationDTO>>;
  public validateProduct(
    body: CampaignProductValidationRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling validateProduct.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4ACampaignProductValidationDTO>(
      'post',
      `${this.basePath}/campaign/validate-product`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }
}
